// detect when the user scrolls down.

import { throttle } from 'lodash';

// Watch for scrolling and set a class on the root.

const html = document.querySelector('html');

// Capture the previous scroll position.
let prevScrollpos = window.pageYOffset;

const setScrollDirectionClass = () => {
	// Position of the current scroll.
	const currentScrollPos = window.pageYOffset;

	// Do nothing if mobile menu active.
	if (html.classList.contains('mobile-menu-active')) {
		return;
	}

	// Do nothing if we have a class set to prevent scroll down effect.
	if (html.classList.contains('no-scrolldown')) {
		return;
	}

	// Do nothing if user has not scrolled more than 250px.
	if (window.pageYOffset < 250) {
		return;
	}

	// Check previous scroll position against the new one.
	if (prevScrollpos > currentScrollPos) {
		html.classList.remove('scrolled-down');
	} else {
		html.classList.add('scrolled-down');
	}
	// Update the previous scroll position.
	prevScrollpos = currentScrollPos;
};

// Attach a passive scroll listener with the throttled function.
window.addEventListener('scroll', throttle(setScrollDirectionClass, 500), {
	passive: true,
});
